export default __webpack_public_path__ + "static/media/document_icon.b1e72f64.svg";